import { createContext, useContext, useEffect, useState } from 'react';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from '../firebase';

const DEFAULT_MAINTENANCE = { active: false, password: '', message: '' };
const DEFAULT_TRIAL_DAYS = 30;

const RemoteConfigContext = createContext({
    maintenanceMode: DEFAULT_MAINTENANCE,
    trialDurationDays: DEFAULT_TRIAL_DAYS,
    loading: true
});

export function RemoteConfigProvider({ children }) {
    const [maintenanceMode, setMaintenanceMode] = useState(DEFAULT_MAINTENANCE);
    const [trialDurationDays, setTrialDurationDays] = useState(DEFAULT_TRIAL_DAYS);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAndActivate(remoteConfig)
            .then(() => {
                try {
                    const raw = getValue(remoteConfig, 'maintenance_mode').asString();
                    if (raw) {
                        setMaintenanceMode({ ...DEFAULT_MAINTENANCE, ...JSON.parse(raw) });
                    }
                } catch (e) {
                    console.warn('Remote Config parse error (maintenance_mode):', e);
                }
                try {
                    const rawTrial = parseInt(getValue(remoteConfig, 'trial_duration_days').asString(), 10);
                    if (!isNaN(rawTrial) && rawTrial >= 0) setTrialDurationDays(rawTrial);
                } catch (e) {
                    console.warn('Remote Config parse error (trial_duration_days):', e);
                }
            })
            .catch(e => console.error('[RemoteConfig] fetch error:', e))
            .finally(() => setLoading(false));
    }, []);

    return (
        <RemoteConfigContext.Provider value={{
            maintenanceMode,
            trialDurationDays,
            loading
        }}>
            {children}
        </RemoteConfigContext.Provider>
    );
}

export const useRemoteConfig = () => useContext(RemoteConfigContext);
